const profile = {
    name: 'Имя',
    avatar: 'Аватар',
    givenName: 'Имя',
    familyName: 'Фамилия',
    middleName: 'Отчество',
    fullname: 'Полное имя',
    nickname: 'Никнейм',
    preferredUsername: 'Предпочитаемое имя пользователя',
    profile: 'Профиль',
    website: 'Веб-сайт',
    gender: 'Пол',
    birthdate: 'Дата рождения',
    zoneinfo: 'Часовой пояс',
    locale: 'Язык',
    address: {
        formatted: 'Адрес',
        streetAddress: 'Улица',
        locality: 'Город',
        region: 'Штат/Область',
        postalCode: 'Почтовый индекс',
        country: 'Страна',
    },
    gender_options: {
        female: 'Женский',
        male: 'Мужской',
        prefer_not_to_say: 'Предпочитаю не говорить',
    },
};
export default Object.freeze(profile);
